import { DollarSign } from 'lucide-react';
import { useHourlyRateRule } from '@/hooks/compensation';

interface HourlyRateDisplayProps {
  profileId: string;
  className?: string;
}

export const HourlyRateDisplay = ({ profileId, className = "" }: HourlyRateDisplayProps) => {
  const { data: hourlyRate, isLoading } = useHourlyRateRule(profileId);

  if (isLoading) {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        <DollarSign className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm text-muted-foreground">Loading...</span>
      </div>
    );
  }

  if (!hourlyRate || hourlyRate === 0) {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        <DollarSign className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm text-muted-foreground">No rate set</span>
      </div>
    );
  }

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <DollarSign className="h-4 w-4 text-muted-foreground" />
      <span className="font-medium">
        ${hourlyRate.toFixed(2)}/hr
      </span>
    </div>
  );
};